import StyledLink from '../StyledLink'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  MONITOR,
  RUNNER,
  STEPS
} from '../routes'
import { PROP_TASK_INSTANCE_ID } from '../constants'
import type { Props } from '../types'

interface Params {
  [PROP_TASK_INSTANCE_ID]: string
}

const LinkToTaskRunSteps = ({
  children,
  [PROP_TASK_INSTANCE_ID]: taskInstanceId,
  isHyperlink
}: Props & Params) => {
  const [isMonitorFlag] = useModule()

  const base = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + RUNNER + '/' + STEPS
    : '/' + MONITOR + '/' + RUNNER + '/' + STEPS

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={base + '/' + taskInstanceId}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToTaskRunSteps
